import React from 'react';
import WebApp from '@twa-dev/sdk';
import { BackButton } from '@twa-dev/sdk/react';
import { ButtonBase, Grid2, Typography } from '@mui/material';
import theme, { TMaterialStyles } from '../../theme';
import BackgroundPattern from '../../../assets/patterns/background-pattern.png';
import { useTranslation } from 'react-i18next';

interface IScreenWrapper extends React.PropsWithChildren {
  onBack?: () => void;
  isAbsolute?: boolean;
}

export const ScreenWrapper: React.FC<IScreenWrapper> = ({
  children,
  onBack,
  isAbsolute,
}) => {
  const { t } = useTranslation();
  return (
    <Grid2 sx={materialStyles.wrapper}>
      {WebApp.platform === 'unknown' && onBack ? (
        <Grid2
          sx={{
            ...materialStyles.headerContainer,
            ...(isAbsolute ? materialStyles.absoluteContainer : {}),
          }}
        >
          <ButtonBase onClick={onBack}>
            <Typography>{t('common.back')}</Typography>
          </ButtonBase>
        </Grid2>
      ) : null}
      {WebApp.platform !== 'unknown' && onBack ? (
        <BackButton onClick={onBack} />
      ) : null}
      {children}
    </Grid2>
  );
};

const materialStyles: TMaterialStyles = {
  wrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: WebApp.safeAreaInset.top,
    paddingBottom: WebApp.safeAreaInset.bottom,
    paddingLeft: WebApp.safeAreaInset.left,
    pr: WebApp.safeAreaInset.right,
    backgroundImage: `url(${BackgroundPattern})`,
    backgroundRepeat: 'repeat',
    backgroundSize: '667px 1000px',
    backgroundColor: theme.palette.grey[50],
  },
  headerContainer: {
    paddingX: '16px',
    paddingY: '12px',
  },
  absoluteContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    paddingX: '16px',
    paddingY: '12px',
    zIndex: 1400,
  },
};
